<template>
  <ToggleableTextField
    :field-enabled="isOnline"
    @update:fieldEnabled="setOnline"
    :switch-label="t$('.event_is_online')"
    :field-info="
      t$('.custom_url_infotext') +
      ` Mehr Information findest Du in unserem <a href='https://suus.atlassian.net/wiki/spaces/GSD/pages/356483073/Wie+erstelle+ich+eine+Online-Veranstaltung+mit+Video-Konferenz'>Hilfesystembeitrag.</a>`
    "
    :field-placeholder="t$('.enter_url')"
    :field-label="callUrlLabel"
    v-model="callUrl"
    button-text="Plattform Link"
    :hide-button="true"
  />
</template>

<script lang="ts">
import {
  computed,
  ComputedRef,
  defineComponent,
  inject,
  WritableComputedRef,
} from "vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import EventFormService from "features/events/form/event-form.service"
import ToggleableTextField from "features/common/forms/form-fields/ToggleableTextField.vue"
import { EventForm } from "components/EventForm/EventForm.vue"

export default defineComponent({
  name: "OnlineConferenceField",
  components: { ToggleableTextField },
  computed: {
    callUrlLabel(): string {
      return this.t$(".enter_custom_call_url")
    },
  },
  setup() {
    const { t$ } = useTranslate("components.event_form")
    const eventFormService: EventFormService<EventForm> =
      inject<EventFormService<EventForm>>("EventFormService")

    eventFormService.registerProperty({
      name: "online",
    })

    const isOnline: ComputedRef<boolean> =
      eventFormService.getFormValue("online")
    const setOnline = (value: boolean) =>
      eventFormService.setFormValue("online", value)

    eventFormService.registerProperty({
      name: "custom_call_url",
    })

    const callUrl: WritableComputedRef<string> = computed({
      get(): string {
        return eventFormService.getFormValue("custom_call_url").value
      },
      set(value: string): void {
        if (value !== eventFormService.getFormValue("custom_call_url").value)
          eventFormService.setFormValue("custom_call_url", value)
      },
    })

    return {
      t$,
      eventFormService,
      isOnline,
      setOnline,
      callUrl,
    }
  },
})
</script>
